import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mui/material';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  loadAgingBalanceResumeList,
  LOAD_AGING_BALANCE_RESUME_LIST
} from 'src/store/actions/accountingActions';
import {
  selectAgingBalanceResumeList,
  selectAgingBalanceResumeListCount,
  selectAgingBalanceResumeQueryOptions
} from 'src/store/selectors/accountingSelector';
import AgingBalanceResumeTable from './AgingBalanceResumeTable';

const AgingBalanceResumeList = () => {
  const dispatch = useDispatch();
  const agingBalanceResumeList = useSelector(selectAgingBalanceResumeList);
  const count = useSelector(selectAgingBalanceResumeListCount);
  const queryOpts = useSelector(selectAgingBalanceResumeQueryOptions);
  const loading = useSelector(
    isLoadingSelector([LOAD_AGING_BALANCE_RESUME_LIST.action])
  );
  const success = useSelector(
    successSelector([LOAD_AGING_BALANCE_RESUME_LIST.action])
  );

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadAgingBalanceResumeList({ ...queryOpts, page: value }));
    },
    [dispatch, queryOpts]
  );

  if (success && !loading && count === 0) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.AGING_BALANCE_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.AGING_BALANCE_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <AgingBalanceResumeTable
      agingBalanceResumeList={agingBalanceResumeList}
      count={count}
      page={queryOpts.page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

export default AgingBalanceResumeList;
